export default __webpack_public_path__ + "static/26-c65fb2c1efe44757992a11f675ff93b3.png";